<template>
    <div>
        <div class="cont">
        <div class="offer-top pl-2">
            <div class="entry_copy_drag">
                <div v-if="index != 0" class="info">
                    <div class="my_tooltip left" style="width: 200px">
                        {{ $t('offer.entry_move_up') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <svg @click="$emit('moveUp', index)" class="arrow_up" width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 15.75V2.25M12 12.75L9 15.75L12 12.75ZM9 15.75L6 12.75L9 15.75Z" stroke="#9598A7"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <svg v-if="entries_length > 1" class="entry_handle" width="14" height="12" viewBox="0 0 14 12"
                    fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: all-scroll; top: 14px; left: 25%">
                    <path d="M1 10.5H13M1 1.5H13H1ZM1 6H13H1Z" stroke="#CED0D5" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <div class="info">
                    <div class="my_tooltip left" style="width: 200px">
                        {{ $t('offer.entry_duplicate') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <svg @click="copy_entry" class="copy_entry" style="margin: 0; top: -2px" width="15" height="15"
                            viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.66668 10.3333H3.25001C2.87429 10.3333 2.51395 10.1841 2.24828 9.91838C1.9826 9.6527 1.83334 9.29237 1.83334 8.91665V3.24998C1.83334 2.87426 1.9826 2.51392 2.24828 2.24824C2.51395 1.98257 2.87429 1.83331 3.25001 1.83331H8.91668C9.2924 1.83331 9.65273 1.98257 9.91841 2.24824C10.1841 2.51392 10.3333 2.87426 10.3333 3.24998V4.66665M6.08334 13.1666H11.75C12.1257 13.1666 12.4861 13.0174 12.7517 12.7517C13.0174 12.486 13.1667 12.1257 13.1667 11.75V6.08331C13.1667 5.70759 13.0174 5.34726 12.7517 5.08158C12.4861 4.8159 12.1257 4.66665 11.75 4.66665H6.08334C5.70762 4.66665 5.34729 4.8159 5.08161 5.08158C4.81593 5.34726 4.66668 5.70759 4.66668 6.08331V11.75C4.66668 12.1257 4.81593 12.486 5.08161 12.7517C5.34729 13.0174 5.70762 13.1666 6.08334 13.1666Z"
                                stroke="#CED0D5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div v-if="index !== entries_length - 1" class="info">
                    <div class="my_tooltip left" style="width: 200px">
                        {{ $t('offer.entry_move_down') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <svg @click="$emit('moveDown', index)" class="arrow_down" width="20" height="20"
                            viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 15.75V2.25M12 12.75L9 15.75L12 12.75ZM9 15.75L6 12.75L9 15.75Z" stroke="#9598A7"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="entry-box">
                <div class="inputs">
                    <div class="inputs-name-holder">
                        <div class="form-floating name">
                            <input v-model="entry.name" @keypress="SimilarEntries()" @blur="showSimilar = false"
                                style="text-transform: none" type="text" class="form-control" id="floatingInput"
                                :placeholder="$t('offer.entry_name_ph')" />
                            <label for="floatingInput">{{ $t('offer.entry_name_label') }}</label>
                        </div>
                        <div v-if="showSimilar" class="similar_entries">
                            <div v-if="SearchEntries.items.length > 0" class="database-items">
                                {{ $t('offer.entry_items_db') }}
                            </div>
                            <div class="entry" v-for="en in SearchEntries.items" :key="en.id"
                                @mousedown="SetSimilar(en)">
                                <div class="left">
                                    <h6 class="name" v-if="en.nazov" v-html="matchName(en.nazov)"></h6>
                                    <span class="description" v-if="en.text"
                                        v-html="en.text.substring(0, 100) + (en.text.length > 100 ? '...' : '')"></span>
                                </div>
                                <div class="right">
                                    <span>{{ en.cena }} €</span>
                                </div>
                            </div>
                            <div v-if="SearchEntries.userEntries.length > 0" class="database-items">
                                {{ $t('offer.entry_history') }}
                            </div>
                            <div class="entry" v-for="en in SearchEntries.userEntries" :key="en.id"
                                @mousedown="SetSimilar(en)">
                                <div class="left">
                                    <h6 class="name" v-if="en.nazov" v-html="matchName(en.nazov)"></h6>
                                    <span class="description" v-if="en.text"
                                        v-html="en.text.substring(0, 100) + (en.text.length > 100 ? '...' : '')"></span>
                                </div>
                                <div class="right">
                                    <span>{{ en.cena_zlava }} €</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="top-inputs">
                        <div class="add-popis-mobile">
                            <span v-show="!showText" @click="showText = true" class="popisNone">{{ $t('offer.entry_add_desc') }}</span>
                            <div v-show="showText" class="form-floating animate__animated animate__fadeInDown"
                                style="height: auto">
                                <vue-editor v-model="entry.text" :editorToolbar="customToolbar"></vue-editor>
                                <div class="textarea-icons">
                                    <svg @click="showText = false" class="trash m-0" width="20" height="21"
                                        viewBox="0 0 20 21" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M9 2.5C8.81434 2.5001 8.63237 2.55188 8.47447 2.64955C8.31658 2.74722 8.18899 2.88692 8.106 3.053L7.382 4.5H4C3.73478 4.5 3.48043 4.60536 3.29289 4.79289C3.10536 4.98043 3 5.23478 3 5.5C3 5.76522 3.10536 6.01957 3.29289 6.20711C3.48043 6.39464 3.73478 6.5 4 6.5V16.5C4 17.0304 4.21071 17.5391 4.58579 17.9142C4.96086 18.2893 5.46957 18.5 6 18.5H14C14.5304 18.5 15.0391 18.2893 15.4142 17.9142C15.7893 17.5391 16 17.0304 16 16.5V6.5C16.2652 6.5 16.5196 6.39464 16.7071 6.20711C16.8946 6.01957 17 5.76522 17 5.5C17 5.23478 16.8946 4.98043 16.7071 4.79289C16.5196 4.60536 16.2652 4.5 16 4.5H12.618L11.894 3.053C11.811 2.88692 11.6834 2.74722 11.5255 2.64955C11.3676 2.55188 11.1857 2.5001 11 2.5H9ZM7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5V14.5C9 14.7652 8.89464 15.0196 8.70711 15.2071C8.51957 15.3946 8.26522 15.5 8 15.5C7.73478 15.5 7.48043 15.3946 7.29289 15.2071C7.10536 15.0196 7 14.7652 7 14.5V8.5ZM12 7.5C11.7348 7.5 11.4804 7.60536 11.2929 7.79289C11.1054 7.98043 11 8.23478 11 8.5V14.5C11 14.7652 11.1054 15.0196 11.2929 15.2071C11.4804 15.3946 11.7348 15.5 12 15.5C12.2652 15.5 12.5196 15.3946 12.7071 15.2071C12.8946 15.0196 13 14.7652 13 14.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5Z"
                                            fill-opacity="0.25" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="select_box" v-bind:class="{
                            cena_zero: typeCena == 0,
                            cena_one: typeCena == 1,
                            cena_two: typeCena == 2,
                            cena_three: typeCena == 3,
                        }">
                            <price-type-select v-model="typeCena" :types="[0, 1, 4, 2, 3]" :flush="true"
                                @change="changeTypeCena"></price-type-select>
                        </div>
                        <div class="inline-price-mobile">
                            <div v-show="entry && entry.type && entry.type.price_from" class="form-floating price">
                                <money v-bind="suffix.price" v-model.number="entry.values.price_from" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena od</label>
                            </div>
                            <div v-show="entry && entry.type && entry.type.price_to" class="form-floating price">
                                <money v-bind="suffix.price" v-model.number="entry.values.price_to" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena do</label>
                            </div>
                        </div>
                        <div v-show="typeCena == 1" class="inline-inputs">
                            <div v-show="entry && entry.type && entry.type.price_from" class="form-floating price">
                                <money v-bind="suffix.price" v-model.number="entry.values.price_from" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena od</label>
                            </div>
                            <div v-show="entry && entry.type && entry.type.price_to" class="form-floating price">
                                <money v-bind="suffix.price" v-model.number="entry.values.price_to" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena do</label>
                            </div>
                        </div>
                        <div class="combobox" data-app>
                            <v-combobox v-show="entry.type.id == 2" v-model="entry.unit" label="Jednotka"
                                :items="unitItems" filled :append-icon="null">
                            </v-combobox>
                        </div>
                        <div class="inline-inputs" :style="{'flex': typeCena == 3 ? '1' : '0 1 100%'}">
                            <div v-show="entry.type.number_of" :class="'form-floating price-for-hours InputPocet ' +
                                this.id +
                                'InputPocet'
                                ">
                                <v-text-field :label="entry.type.id == 4 ? $t('offer.entry_count_from') : $t('offer.entry_count')"
                                    v-model="entry.values.number_of" @input="handleInput('number_of', 'InputPocet')"
                                    @blur="handleBlur('number_of', 'InputPocet')"
                                    :suffix="suffix.number_of.suffix.toUpperCase()"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(1, 1)"> + </span>
                                    <span @click="stepper(1, 0)"> - </span>
                                </div>
                            </div>
                            <div v-show="entry.type.number_of_to" :class="'form-floating price-for-hours InputPocet ' +
                                this.id +
                                'InputPocetTo'
                                ">
                                <v-text-field :label="$t('offer.entry_count_to')" v-model="entry.values.number_of_to"
                                    @input="handleInput('number_of_to', 'InputPocetTo')"
                                    @blur="handleBlur('number_of_to', 'InputPocetTo')"
                                    :suffix="suffix.number_of_to.suffix.toUpperCase()"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(4, 1)"> + </span>
                                    <span @click="stepper(4, 0)"> - </span>
                                </div>
                            </div>
                            <div v-show="entry.type.tariff" :class="'form-floating price-for-hours InputSadzba ' +
                                this.id +
                                'InputSadzba'
                                ">
                                <v-text-field label="sadzba" v-model="entry.values.tariff"
                                    @input="handleInput('tariff', 'InputSadzba')"
                                    @blur="handleBlur('tariff', 'InputSadzba')"
                                    :suffix="suffix.tariff.suffix"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(2, 1)"> + </span>
                                    <span @click="stepper(2, 0)"> - </span>
                                </div>
                            </div>
                            <div v-if="typeCena != 3" class="form-floating price-for-hours InputPocet" style="width: min-content;">
                                <input style="text-transform: none" type="text" class="form-control" id="floatingInput"
                                    v-model="entry.dph" @blur="calcDph" placeholder="DPH %" />
                                <label for="floatingInput">DPH %</label>
                            </div>
                            <div class="form-floating price-for-hours InputPocet" style="width: min-content;">
                                <input style="text-transform: none" type="text" class="form-control" id="floatingInput"
                                    v-model="entry.values.discount"
                                    :placeholder="$t('offer.entry_discount') + ' ' + (discountEur ? currentCurrency : '%')" />
                                <label for="floatingInput">{{ $t('offer.entry_discount') }} {{ discountEur ? currentCurrency : '%' }}</label>
                                <div class="check-holder">
                                    <span>%</span>
                                    <input v-model="discountEur" type="checkbox" class="toggle percent-eur" />
                                    <span>{{ currentCurrency }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="entry.type.id != 3" class="summary-last">
                            <div v-if="entry.type.id == 1 || entry.type.id == 4" class="sum form-floating">
                                <div v-if="showDiscount" class="saled-price">{{
                                    rangePriceWithoutDph().from.toFixed(2).toString() + ' - ' +
                                    rangePriceWithoutDph().to.toFixed(2).toString() + ' ' + currentCurrency }}</div>
                                <input
                                    :value="rangePriceWithoutDph().discountPriceFrom.toFixed(2).toString() + ' - ' + rangePriceWithoutDph().discountPriceTo.toFixed(2).toString() + ' ' + currentCurrency"
                                    type="text" class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0" for="floatingInput">Cena od - do bez DPH</label>
                                <label v-else for="floatingInput">Cena od - do</label>
                            </div>
                            <div v-else-if="!entry.type.price" class="sum form-floating">
                                <div v-if="showDiscount" class="saled-price">{{ autoPriceWithoutDph().price.toFixed(2).toString()+ ' ' + currentCurrency }}</div>
                                <input :value="autoPriceWithoutDph().discountPrice.toFixed(2).toString() + ' ' + currentCurrency" type="text"
                                    class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0" for="floatingInput">Cena bez DPH</label>
                                <label v-else for="floatingInput">Cena</label>
                            </div>
                            <div v-else-if="entry.type.price" class="sum form-floating">
                                <div v-if="showDiscount" class="saled-price">{{ ownPriceWithoutDph().price.toFixed(2).toString()
                                    + ' ' + currentCurrency }}</div>
                                <input :value="ownPriceWithoutDph().discountPrice.toFixed(2).toString() + ' ' + currentCurrency" type="text"
                                    class="form-control" @blur="changeOwnPrice($event.target.value)" id="floatingInput"
                                    placeholder="" />
                                <label v-if="dph() > 0" for="floatingInput">{{ $t('offer.entry_price_vat') }}</label>
                                <label v-else for="floatingInput">{{ $t('offer.entry_price') }}</label>
                            </div>
                        </div>
                        <div v-else class="summary-last" style="flex: 1;">
                            <div v-if="subEntriesPrice_ == subEntriesPriceTo_" class="sum form-floating" style="width: 100%;">
                                <div v-if="showDiscount" class="saled-price">
                                    {{ subEntriesPriceWithoutDph().price.toFixed(2).toString() + ' ' + currentCurrency }}
                                </div>
                                <input :value="subEntriesPriceWithoutDph().discountPrice.toFixed(2).toString() + ' ' + currentCurrency"
                                    type="text" class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0 || subEntriesPriceDiscount_ != subEntriesPrice_"
                                    for="floatingInput">Cena spolu bez DPH</label>
                                <label v-else for="floatingInput">Cena spolu</label>
                            </div>
                            <div v-else class="sum form-floating" style="width: 100%;">
                                <div v-if="showDiscount" class="saled-price">{{
                                    rangePriceWithoutDph(true).from.toFixed(2).toString() + ' - ' +
                                    rangePriceWithoutDph(true).to.toFixed(2).toString() + ' ' + currentCurrency }}</div>
                                <input
                                    :value="rangePriceWithoutDph(true).discountPriceFrom.toFixed(2).toString() + ' - ' + rangePriceWithoutDph(true).discountPriceTo.toFixed(2).toString() + ' ' + currentCurrency"
                                    type="text" class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0 || subEntriesPriceDiscount_ != subEntriesPrice_"
                                    for="floatingInput">Cena spolu od - do bez DPH</label>
                                <label v-else for="floatingInput">Cena spolu od - do</label>
                            </div>
                        </div>
                    </div>
                    <div class="add-popis">
                        <div v-show="showText" class="form-floating animate__animated animate__fadeInDown editor-wrapper"
                            style="height: auto; position: relative;">
                            <vue-editor v-model="entry.text" :editorToolbar="customToolbar"></vue-editor>
                            <div
                                v-if="loadingGenerateDescription"
                                class="ai-generate-overlay"
                            >
                                <span class="ai-generate-text">
                                    Generujem popis<span class="dots">...</span>
                                </span>
                            </div>
                            <!-- <tiptap-editor v-model="entry.text" /> -->
                            <div class="textarea-icons">
                                <ai-description-button
                                    :is-paid="!!is_paid"
                                    :entry-name="entry.name"
                                    :loading="loadingGenerateDescription"
                                    @openPaidModal="openAiModal = true"
                                    @openSettings="openAiSettingsModal = true"
                                />
                                <svg @click="showText = false" class="trash m-0" width="20" height="21"
                                    viewBox="0 0 20 21" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M9 2.5C8.81434 2.5001 8.63237 2.55188 8.47447 2.64955C8.31658 2.74722 8.18899 2.88692 8.106 3.053L7.382 4.5H4C3.73478 4.5 3.48043 4.60536 3.29289 4.79289C3.10536 4.98043 3 5.23478 3 5.5C3 5.76522 3.10536 6.01957 3.29289 6.20711C3.48043 6.39464 3.73478 6.5 4 6.5V16.5C4 17.0304 4.21071 17.5391 4.58579 17.9142C4.96086 18.2893 5.46957 18.5 6 18.5H14C14.5304 18.5 15.0391 18.2893 15.4142 17.9142C15.7893 17.5391 16 17.0304 16 16.5V6.5C16.2652 6.5 16.5196 6.39464 16.7071 6.20711C16.8946 6.01957 17 5.76522 17 5.5C17 5.23478 16.8946 4.98043 16.7071 4.79289C16.5196 4.60536 16.2652 4.5 16 4.5H12.618L11.894 3.053C11.811 2.88692 11.6834 2.74722 11.5255 2.64955C11.3676 2.55188 11.1857 2.5001 11 2.5H9ZM7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5V14.5C9 14.7652 8.89464 15.0196 8.70711 15.2071C8.51957 15.3946 8.26522 15.5 8 15.5C7.73478 15.5 7.48043 15.3946 7.29289 15.2071C7.10536 15.0196 7 14.7652 7 14.5V8.5ZM12 7.5C11.7348 7.5 11.4804 7.60536 11.2929 7.79289C11.1054 7.98043 11 8.23478 11 8.5V14.5C11 14.7652 11.1054 15.0196 11.2929 15.2071C11.4804 15.3946 11.7348 15.5 12 15.5C12.2652 15.5 12.5196 15.3946 12.7071 15.2071C12.8946 15.0196 13 14.7652 13 14.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5Z"
                                        fill-opacity="0.25" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="entry_right" :class="{ mobile_roll: roll }">
                <!-- Zmazať položku -->
                <div class="action-icon-wrap">
                    <div class="action-tooltip">
                        <span class="action-tooltip__title">{{ $t('offer.action_delete_title') }}</span>
                        <div class="action-tooltip__line"></div>
                        {{ $t('offer.action_delete_desc') }}
                    </div>
                    <button type="button" class="action-icon action-icon--danger" @click="$emit('remove', id)">
                        <svg width="16" height="16" viewBox="0 0 15 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4H2.33333H13" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.33301 3.99992V2.66659C4.33301 2.31296 4.47348 1.97382 4.72353 1.72378C4.97358 1.47373 5.31272 1.33325 5.66634 1.33325H8.33301C8.68663 1.33325 9.02577 1.47373 9.27582 1.72378C9.52587 1.97382 9.66634 2.31296 9.66634 2.66659V3.99992M11.6663 3.99992V13.3333C11.6663 13.6869 11.5259 14.026 11.2758 14.2761C11.0258 14.5261 10.6866 14.6666 10.333 14.6666H3.66634C3.31272 14.6666 2.97358 14.5261 2.72353 14.2761C2.47348 14.026 2.33301 13.6869 2.33301 13.3333V3.99992H11.6663Z" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.66699 7.33325V11.3333" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.33301 7.33325V11.3333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <!-- Započítať / nezapočítať do celkovej ceny -->
                <div class="action-icon-wrap">
                    <div class="action-tooltip">
                        <span class="action-tooltip__title">{{ !entry.exclude ? $t('offer.entry_exclude') : $t('offer.entry_include') }} {{ $t('offer.entry_in_total') }} ponuky</span>
                        <div class="action-tooltip__line"></div>
                        {{ !entry.exclude ? $t('offer.entry_excluded_msg') : $t('offer.entry_included_msg') }} tvojej ponuky.
                    </div>
                    <button type="button" class="action-icon" :class="{ 'action-icon--active': entry.exclude }" @click="entry.exclude = !entry.exclude">
                        <svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM8 19.004h1.994C11.097 23 13.733 25 17.9 25c1.585 0 2.951-.216 4.1-.648v-2.373c-1.209.494-2.32.74-3.334.74-1.419 0-2.512-.271-3.277-.815-.766-.545-1.416-1.511-1.949-2.9h4.956l.8-2.003h-6.184c-.03-.378-.045-.806-.045-1.285 0-.416.019-.748.056-.995h7.096l.811-2.003h-7.422c.713-2.292 2.316-3.438 4.809-3.438a8.92 8.92 0 013.683.776V7.532A14.002 14.002 0 0018.103 7c-4.16 0-6.833 1.906-8.02 5.718H8.812L8 14.721h1.69a12.95 12.95 0 00-.057 1.25c0 .332.011.675.034 1.03H8.81z" fill-rule="evenodd"></path>
                        </svg>
                    </button>
                </div>

                <!-- Uložiť do Položiek a cien -->
                <div class="action-icon-wrap">
                    <div class="action-tooltip">
                        <span class="action-tooltip__title">{{ isImported ? $t('offer.action_import_done_title') : $t('offer.action_import_title') }}</span>
                        <div class="action-tooltip__line"></div>
                        {{ isImported ? $t('offer.action_import_done_desc') : $t('offer.action_import_desc') }}
                    </div>
                    <button type="button" class="action-icon action-icon--import" :class="{ 'action-icon--done': isImported }" :disabled="importing" @click="importToItems">
                        <svg v-if="isImported" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <svg v-else width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h6"></path>
                            <line x1="18" y1="3" x2="18" y2="9"></line>
                            <line x1="21" y1="6" x2="15" y2="6"></line>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="mb-4 popeditor-trigger-holder">
            <span v-show="!showText" @click="showText = true" class="popisNone">{{ $t('offer.entry_add_desc') }}</span>
        </div>
        <div v-if="entry.subEntries.length > 0" class="roll-subentires" @click="roll = !roll">
            <svg class="tooltip_hover" :class="{ 'arrow_down': roll }" width="20" height="20" viewBox="0 0 20 20"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15.75V2.25M12 12.75L9 15.75L12 12.75ZM9 15.75L6 12.75L9 15.75Z" stroke="#9598A7"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ roll ? $t('offer.entry_expand_sub') : $t('offer.entry_collapse_sub') }}
        </div>
        <div class="subentries mt-2">
            <draggable v-model="entry.subEntries" @change="sendData" handle=".subentry_handle">
                <transition-group tag="div" v-bind:class="{ 'd-none': roll }">
                    <div v-for="e in entry.subEntries" :key="e.uuid" class="subentry mb-4">
                        <sub-entry :id="e.id" :is="e.component" :newData="e.data" :units="units"
                            :getTariff="getSubTariff" :newTariff="newSubTariff" :uuidOffer="uuidOffer"
                            :currentCurrency="currentCurrency" :default_dph="default_dph"
                            :parentUuid="entry.uuid" :importedSources="importedSources"
                            @remove="removeSubEntry($event)" @data="dataSubEntry($event, e.id)" />
                    </div>
                </transition-group>
            </draggable>

            <div class="subentry-actions-holder">
                <div class="subentry-actions-right">
                    <button @click="addSubEntry(true)" class="add-subentry">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.5421 10.4171L10.4171 12.5421C10.2096 12.7496 9.87309 12.7496 9.66555 12.5421C9.45801 12.3346 9.45801 11.9981 9.66555 11.7906L10.8839 10.5722H5.08334C2.44693 10.5722 0.302094 8.42739 0.302094 5.79097V0.83264C0.302094 0.53939 0.540093 0.30139 0.833344 0.30139C1.12659 0.30139 1.36459 0.53939 1.36459 0.83264V5.79097C1.36459 7.8416 3.03272 9.50972 5.08334 9.50972H10.8839L9.66555 8.29139C9.45801 8.08385 9.45801 7.74739 9.66555 7.53985C9.76897 7.43643 9.90497 7.38401 10.041 7.38401C10.177 7.38401 10.313 7.43572 10.4164 7.53985L12.5414 9.66485C12.7489 9.87239 12.7489 10.2088 12.5414 10.4164L12.5421 10.4171Z"
                                fill="#182039" />
                        </svg>
                        {{ $t('offer.entry_add_sub') }}
                    </button>
                    <div class="pridat_obrazky_text" @click="openModal = true">
                        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.1875 0.125H5.3125C4.71484 0.125 4.25 0.623047 4.25 1.1875V4.375H9.5625V2.25H15.9375V12.875H20.1875C20.752 12.875 21.25 12.4102 21.25 11.8125V1.1875C21.25 0.623047 20.752 0.125 20.1875 0.125ZM7.70312 3.54492C7.70312 3.71094 7.53711 3.84375 7.4043 3.84375H6.4082C6.24219 3.84375 6.10938 3.71094 6.10938 3.54492V2.54883C6.10938 2.41602 6.24219 2.25 6.4082 2.25H7.4043C7.53711 2.25 7.70312 2.41602 7.70312 2.54883V3.54492ZM19.3906 10.4512C19.3906 10.6172 19.2246 10.75 19.0918 10.75H18.0957C17.9297 10.75 17.7969 10.6172 17.7969 10.4512V9.45508C17.7969 9.32227 17.9297 9.15625 18.0957 9.15625H19.0918C19.2246 9.15625 19.3906 9.32227 19.3906 9.45508V10.4512ZM19.3906 6.99805C19.3906 7.16406 19.2246 7.29688 19.0918 7.29688H18.0957C17.9297 7.29688 17.7969 7.16406 17.7969 6.99805V6.00195C17.7969 5.86914 17.9297 5.70312 18.0957 5.70312H19.0918C19.2246 5.70312 19.3906 5.86914 19.3906 6.00195V6.99805ZM19.3906 3.54492C19.3906 3.71094 19.2246 3.84375 19.0918 3.84375H18.0957C17.9297 3.84375 17.7969 3.71094 17.7969 3.54492V2.54883C17.7969 2.41602 17.9297 2.25 18.0957 2.25H19.0918C19.2246 2.25 19.3906 2.41602 19.3906 2.54883V3.54492ZM13.8125 5.4375H1.0625C0.464844 5.4375 0 5.93555 0 6.5V16.0625C0 16.6602 0.464844 17.125 1.0625 17.125H13.8125C14.377 17.125 14.875 16.6602 14.875 16.0625V6.5C14.875 5.93555 14.377 5.4375 13.8125 5.4375ZM3.1875 7.5625C3.75195 7.5625 4.25 8.06055 4.25 8.625C4.25 9.22266 3.75195 9.6875 3.1875 9.6875C2.58984 9.6875 2.125 9.22266 2.125 8.625C2.125 8.06055 2.58984 7.5625 3.1875 7.5625ZM12.75 15H2.125V13.9375L4.25 11.8125L5.3125 12.875L9.5625 8.625L12.75 11.8125V15Z"
                                fill="#5F6368" />
                        </svg>
                        {{ $t('offer.entry_add_images') }}
                        <span v-if="file_count > 0" class="file_count">{{ file_count }}</span>
                    </div>
                    <entry-images-modal :openModal="openModal" @closeModal="openModal = false" :entry="entry"
                        :entry_title_image="entry_title_image" :entry_title_image_mobile="entry_title_image_mobile"
                        :copy_title_image="copy_title_image" :copy_title_image_mobile="copy_title_image_mobile"
                        :copied_entry="copied_entry" :premium="premium" @setFiles="setFiles($event)"
                        @sendfile="sendfile($event)" @file_count="file_count = $event"
                        @sendfile_mobile="sendfile_mobile($event)" />
                </div>
                <div class="subentry-actions-right">
                </div>
            </div>
        </div>
        <div class="offer-bottom">
            <div class="inter_poznamka" :style="entry.inter_note.length > 0
                ? 'width: ' + entry.inter_note.length * 10 + 'px;'
                : ''
                ">
                <a v-if="entry.inter_note == '' && !inter_note_check" class="one" @click="inter_note_click">{{ $t('offer.entry_add_note') }}</a>
                <a v-else-if="entry.inter_note != '' && !inter_note_check" class="two" @click="inter_note_click">{{
                    entry.inter_note }}</a>
                <input v-show="inter_note_check" ref="inter_poznamka" @keyup.enter="inter_note_check = false"
                    @blur="inter_note_check = false" type="text" v-model="entry.inter_note"
                    :style="entry.inter_note.length <= 0 ? 'border: none;' : ''" />
            </div>
            <div class="summary">
            </div>
        </div>
    </div>
    <paid-modal v-if="openAiModal" :redirect="true" @close="openAiModal = false"/>
    <ai-settings-modal
        :open="openAiSettingsModal"
        :entry="entry"
        @close="openAiSettingsModal = false"
        @save="saveAiSettings"
        @generate="generateDescriptionWithAi"
    />
    </div>
</template>

<script>
import info from "./info.json";
import { EventBus } from './EventBus';
import SubEntry from "./SubEntry.vue";
import draggable from "vuedraggable/src/vuedraggable";
import { Money } from "v-money";
import { VueEditor } from "vue2-editor";
import EntryImagesModal from "./EntryImagesModal.vue";
import TiptapEditor from '@/components/TiptapEditor.vue'
import PaidModalIcon from "../../vue_components/PaidModalIcon.vue";
import PaidModal from "../../vue_components/PaidModal.vue";
import AiDescriptionButton from "./AiDescriptionButton.vue";
import AiSettingsModal from "./AiSettingsModal.vue";
import PriceTypeSelect from "./PriceTypeSelect.vue";
export default {
    components: {
        SubEntry,
        Money,
        draggable,
        VueEditor,
        EntryImagesModal,
        TiptapEditor,
        PaidModalIcon,
        PaidModal,
        AiDescriptionButton,
        AiSettingsModal,
        PriceTypeSelect,
    },
    props: [
        "index",
        "newData",
        "id",
        "entries_length",
        "getTariff",
        "newTariff",
        "copied_entry",
        "units",
        "uuidOffer",
        "premium",
        "default_dph",
        "entry_title_image",
        "entry_title_image_mobile",
        "copy_title_image",
        "copy_title_image_mobile",
        "is_paid",
        "importedSources",
    ],
    data() {
        return {
            userEntries: [],
            ItemsAndPrices: [],
            openModal: false,
            openAiModal: false,
            openAiSettingsModal: false,
            inter_note_check: false,
            importing: false,
            importedLocal: false,
            customToolbar: [
                ["bold", "italic", "underline", "link"],
                [
                    {
                        list: "ordered",
                    },
                    {
                        list: "bullet",
                    },
                ],
            ],
            entry: {
                id: "",
                uuid: "",
                name: "",
                text: "",
                inter_note: "",
                dph: 0,
                unit: "",
                type: {},
                values: {},
                exclude: false,
                subEntries: [],
                files: [],
            },
            file_count: 0,
            suffix: {},
            unitItems: ["ks", "m2", "hod", "bm", "kpl", "m", "km", "NS", "MD", "MH"],
            cenaItems: [
                {
                    text: this.$t('offer.entry_type_hourly'),
                    value: 0,
                },
                {
                    text: this.$t('offer.entry_type_range'),
                    value: 1,
                },
                {
                    text: this.$t('offer.entry_type_hour_range'),
                    value: 4,
                },
                {
                    text: this.$t('offer.entry_type_custom'),
                    value: 2,
                },
                {
                    text: this.$t('offer.entry_type_subitems'),
                    value: 3,
                },
            ],
            typeCena: null,
            showText: false,
            showDiscount: false,
            showSimilar: false,
            isOwnPrice: false,
            newSubTariff: null,
            getSubTariff: false,
            price: 0,
            price_to: null,
            price_discount: 0,
            price_to_discount: null,
            price_overall: 0,
            price_to_overall: null,
            price_overall_from_to: null,
            price_discount_overall: 0,
            price_to_discount_overall: null,
            price_discount_overall_from_to: null,
            roll: false,
            edited: false,
            discountEur: false,
            currentCurrency: "€",
            subEntriesPrice_: 0,
            subEntriesPriceDiscount_: 0,
            subEntriesPriceTo_: 0,
            subEntriesPriceToDiscount_: 0,
            dph: function () {
                if (this.entry.dph == null || this.entry.dph == undefined || this.entry.dph == "") {
                    return 0;
                } else {
                    if (isNaN(parseFloat(this.entry.dph))) {
                        return 0;
                    }
                    return parseFloat(this.entry.dph);
                }
            },
            calcOwnPrice: _.debounce(function () {
                this.cal_price();
                this.saveAllAfterChange();
            }, 100),
            calcOwnPriceDiscount: function () {
                this.changeDiscountInput();
                this.saveAllAfterChange();
            },
            ownPriceWithoutDph: function () {
                let price = parseFloat(this.entry.values.own_price);
                let discount = 0;
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        discount = parseFloat(this.entry.values.discount);
                    } else {
                        discount = price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return {price: price, discountPrice: price - discount };
            },
            ownPriceWithDph: function () {
                return parseFloat(this.entry.values.own_price) * (1 + this.dph() / 100);
            },
            ownPriceDiscount: function (isWithDph = false) {
                let price = this.entry.values.own_price;
                if (isWithDph && this.dph() > 0) {
                    price = this.ownPriceWithDph();
                }
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        return parseFloat(this.entry.values.discount);
                    } else {
                        return price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return 0;
            },
            ownPrice: function () {
                return this.ownPriceWithDph() - this.ownPriceDiscount(true);
            },
            autoPriceWithoutDph: function () {
                let price = parseFloat(this.entry.values.auto_price);
                let discount = 0;
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        discount = parseFloat(this.entry.values.discount);
                    } else {
                        discount = price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return {price: price, discountPrice: price - discount };
            },
            autoPriceWithDph: function () {
                return parseFloat(this.entry.values.auto_price) * (1 + this.dph() / 100);
            },
            autoPriceDiscount: function (isWithDph = false) {
                let price = this.entry.values.auto_price;
                if (isWithDph && this.dph() > 0) {
                    price = this.autoPriceWithDph();
                }
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        return parseFloat(this.entry.values.discount);
                    } else {
                        return price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return 0;
            },
            autoPrice: function () {
                return this.autoPriceWithDph() - this.autoPriceDiscount(true);
            },
            subEntriesPriceWithoutDph: function () {
                let price = parseFloat(this.subEntriesPrice_);
                let discount = 0;
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        discount = parseFloat(this.entry.values.discount);
                    } else {
                        discount = price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return {price: price, discountPrice: price - discount }
            },
            subEntriesPriceWithDph: function (price = this.subEntriesPriceDiscount_) {
                return parseFloat(price * (1 + this.dph() / 100));
            },
            subEntriesPriceDiscount: function (price = this.subEntriesPriceDiscount_, isWithDph = false) {
                if (isWithDph && this.dph() > 0) {
                    price = this.subEntriesPriceWithDph(price);
                }
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        return parseFloat(this.entry.values.discount);
                    } else {
                        return price * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return 0;
            },
            subEntriesPrice: function () {
                return this.subEntriesPriceWithDph() - this.subEntriesPriceDiscount(this.subEntriesPriceDiscount_,true);
            },
            rangePriceWithoutDph: function (isSubEntries = false) {
                let from = isSubEntries ? parseFloat(this.subEntriesPrice_) : parseFloat(this.entry.values.price_from);
                let to = isSubEntries ? parseFloat(this.subEntriesPriceTo_) : parseFloat(this.entry.values.price_to);
                let discountFrom = 0;
                let discountTo = 0;
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        discountFrom = parseFloat(this.entry.values.discount);
                        discountTo = parseFloat(this.entry.values.discount);
                    } else {
                        discountFrom = from * (parseFloat(this.entry.values.discount) / 100);
                        discountTo = to * (parseFloat(this.entry.values.discount) / 100);
                    }
                }
                return {from: from, to: to, discountPriceFrom: from - discountFrom, discountPriceTo: to - discountTo };
            },
            rangePriceDiscount: function (isWithDph = false) {
                let from = this.entry.values.price_from
                let to = this.entry.values.price_to
                if (isWithDph && this.dph() > 0) {
                    from = this.rangePriceWithDph().from
                    to = this.rangePriceWithDph().to
                }
                if (this.entry.values.discount > 0) {
                    if (this.discountEur) {
                        return { from: parseFloat(this.entry.values.discount), to: parseFloat(this.entry.values.discount) };
                    } else {
                        return {
                            from: from * (parseFloat(this.entry.values.discount) / 100),
                            to: to * (parseFloat(this.entry.values.discount) / 100)
                        };
                    }
                }
                return { from: 0, to: 0 };
            },
            rangePrice: function (isSubEntries = false) {
                let from = this.rangePriceWithDph().from - this.rangePriceDiscount(true).from;
                let to = this.rangePriceWithDph().to - this.rangePriceDiscount(true).to;
                if (isSubEntries) {
                    from = this.rangePriceWithDph(true).from - this.subEntriesPriceDiscount(this.subEntriesPrice_,true);
                    to = this.rangePriceWithDph(true).to - this.subEntriesPriceDiscount(this.subEntriesPriceTo_,true);
                }
                return { from, to };
            },
            rangePriceWithDph: function (isSubEntries = false) {
                let from = parseFloat(this.entry.values.price_from) * (1 + this.dph() / 100);
                let to = parseFloat(this.entry.values.price_to) * (1 + this.dph() / 100);
                if (isSubEntries) {
                    from = parseFloat(this.subEntriesPriceDiscount_) * (1 + this.dph() / 100);
                    to = parseFloat(this.subEntriesPriceToDiscount_) * (1 + this.dph() / 100);
                }
                return { from, to };
            },
            priceWithoutDiscount: function () {
                if (this.entry && this.entry.type && this.entry.type.id == 0) {
                    return this.entry.values.auto_price
                }
                if (this.entry && this.entry.type && this.entry.type.id == 2) {
                    return this.entry.values.own_price
                }
                if (this.entry && this.entry.type && this.entry.type.id == 3) {
                    return this.subEntriesPrice_
                }
                if (this.entry && this.entry.type && (this.entry.type.id == 1 || this.entry.type.id == 4)) {
                    return this.entry.values.price_from
                }
                return null
            },
            priceWithoutDiscountTo: function () {
                if (this.entry && this.entry.type && (this.entry.type.id == 1 || this.entry.type.id == 4)) {
                    return this.entry.values.price_to
                }
                return null
            },
            loadingGenerateDescription: false,
            aiSettings: {},
        };
    },
    created() {
        this.suffix = {
            price: {
                thousands: " ",
                suffix: " " + this.currentCurrency,
                precision: 2,
            },
            discount: {
                suffix: "%",
                precision: 0,
            },
            number_of: {
                suffix: " hod",
                precision: 2,
            },
            number_of_to: {
                suffix: " hod",
                precision: 2,
            },
            tariff: {
                suffix: " " + this.currentCurrency + " /hod",
                precision: 0,
            },
        }
        this.entry.uuid = this.makeuuid(6);
        this.entry.type = info.types[0];
        this.typeCena = 0;
        this.entry.values = {
            number_of: 0,
            number_of_to: 0,
            tariff: 0,
            price_from: 0,
            price_to: 0,
            auto_price: 0,
            own_price: 0,
            discount: 0,
        };
        if (this.newData != null) {
            this.entry = this.newData;
            this.entry.dph = this.newData.dph;
            this.typeCena = this.newData.type;
            this.entry.type = info.types[this.newData.type];
            this.isOwnPrice = this.newData.isOwnPrice;
            this.discountEur = this.newData.discount_type == 1 ? true : false;
            if (this.entry.text) this.showText = true;
            if (this.entry.values.discount != 0) this.showDiscount = true;
            if (this.entry.subEntries) {
                this.entry.subEntries.forEach((sub) => {
                    sub.component = SubEntry;
                });
            }
            this.sendData();
        }
        if (this.copied_entry) {
            const deepCopy = (data) => JSON.parse(JSON.stringify(data));

            this.entry = deepCopy(this.copied_entry);
            this.isOwnPrice = !!this.copied_entry.isOwnPrice;
            this.entry.dph = this.copied_entry.dph || 0;

            this.price = this.copied_entry.price ? deepCopy(this.copied_entry.price) : 0;
            this.price_to = this.copied_entry.price_to ? deepCopy(this.copied_entry.price_to) : null;
            this.price_discount = this.copied_entry.price_discount ? deepCopy(this.copied_entry.price_discount) : 0;
            this.price_to_discount = this.copied_entry.price_to_discount ? deepCopy(this.copied_entry.price_to_discount) : null;

            this.typeCena = this.copied_entry.type?.id || 0;
            this.entry.type = this.copied_entry.type ? deepCopy(this.copied_entry.type) : null;

            this.entry.files = this.copied_entry.copy_files || "";
            this.entry.copy_title_file = this.copy_title_image || "";
            this.entry.copy_title_file_mobile = this.copy_title_image_mobile || "";

            this.showText = !!this.entry.text;
            this.showDiscount = this.entry.values?.discount !== 0;

            this.entry.subEntries?.forEach((sub) => {
                sub.component = SubEntry;
            });

            this.sendData();

        }

    },
    methods: {
        async generateDescriptionWithAi(settingsFromModal) {
            if (!this.entry.name) {
                return;
            }

            // ak beží predchádzajúca animácia, zruš ju
            if (this._aiTypewriterTimeout) {
                clearTimeout(this._aiTypewriterTimeout);
                this._aiTypewriterTimeout = null;
            }

            const originalText = this.entry.text;
            // hneď vymaž aktuálny popis, nech je vidno len overlay „Generujem...”
            this.entry.text = '';
            this.loadingGenerateDescription = true;

            const effectiveSettings = settingsFromModal || this.aiSettings || {};

            try {
                const { data } = await axios.post('/api/ai/product-description', {
                    name: this.entry.name,
                    language: 'sk',
                    entry_uuid: this.entry.uuid,
                    settings: effectiveSettings
                });

                const description = data && data.description ? data.description : '';

                // Typovacia animácia – rýchlosť podľa dĺžky textu (kratší rýchlejšie, dlhší pomalšie, ale rozumne)
                this.entry.text = '';
                let index = 0;
                const fullText = description;
                const length = fullText.length || 1;

                let targetTotalMs;
                if (length <= 80) {
                    // krátky text – rýchlejší (~0.9–1.2s)
                    targetTotalMs = 1000;
                } else if (length <= 200) {
                    // stredný text (~1.5–2s)
                    targetTotalMs = 1700;
                } else {
                    // dlhší text (~2.2–3s)
                    targetTotalMs = 2400;
                }

                const stepMs = Math.max(5, Math.min(35, Math.round(targetTotalMs / length)));

                const typeNextChar = () => {
                    if (index > fullText.length) {
                        this._aiTypewriterTimeout = null;
                        return;
                    }
                    this.entry.text = fullText.slice(0, index);
                    index += 1;
                    this._aiTypewriterTimeout = setTimeout(typeNextChar, stepMs);
                };

                typeNextChar();
            } catch (e) {
                console.error('Failed to generate AI description:', e);
                this.entry.text = originalText;
                if (this.$toast) {
                    this.$toast.error('Nepodarilo sa vygenerovať popis', { timeout: 2000 });
                }
            } finally {
                this.loadingGenerateDescription = false;
            }
        },
        saveAiSettings(newSettings) {
            this.aiSettings = { ...newSettings };
            this.openAiSettingsModal = false;
        },
        async loadAiSettings() {
            try {
                const { data } = await axios.get('/api/ai/settings');
                if (data.settings) {
                    this.aiSettings = { ...data.settings };
                }
            } catch (e) {
                console.error('Failed to load AI settings:', e);
            }
        },
        isNotNumber: function (value) {
            return isNaN(parseFloat(value));
        },
        setSubEntriesPrice: function () {
            this.subEntriesPrice_ = 0;
            this.subEntriesPriceDiscount_ = 0;
            this.subEntriesPriceTo_ = 0;
            this.subEntriesPriceToDiscount_ = 0;
            this.entry.subEntries.forEach((sub) => {
                if (sub.data.type && !sub.data.exclude) {
                    this.subEntriesPrice_ += parseFloat(sub.data.price);
                    this.subEntriesPriceDiscount_ += parseFloat(sub.data.price_discount);
                    this.subEntriesPriceTo_ += this.isNotNumber(sub.data.price_to) ? parseFloat(sub.data.price) : parseFloat(sub.data.price_to);
                    this.subEntriesPriceToDiscount_ += this.isNotNumber(sub.data.price_to_discount) ? parseFloat(sub.data.price_discount) : parseFloat(sub.data.price_to_discount);
                }
            });
        },
        calcDph: _.debounce(function () {
            if (isNaN(parseFloat(this.entry.dph))) {
                this.entry.dph = "";
            }
            this.cal_price();
            this.saveAllAfterChange();
        }, 100),
        changeOwnPrice: _.debounce(function (value) {
            if (value == null ||
                value == undefined ||
                value == "" ||
                isNaN(parseFloat(value))) {
                this.entry.values.own_price = 0;
            } else {
                this.entry.values.own_price = parseFloat(value.replace(',', '.'));
            }
        }, 100),
        changeDiscountInput() {
            if (this.entry.values.discount > 0) {
                this.showDiscount = true;
            } else {
                this.showDiscount = false;
            }
        },
        updateSuffix() {
            this.suffix.price.suffix = " " + this.currentCurrency;
            this.suffix.tariff.suffix = " " + this.currentCurrency + " /" + this.entry.unit;
        },
        setFiles(files) {
            this.entry.copy_files = files;
        },
        sendfile_mobile(files) {
            this.entry.copy_title_file_mobile = files;
        },
        sendfile(files) {
            this.entry.copy_title_file = files;
        },
        copy_entry() {
            this.$emit("copy_entry", this.id);
        },
        importToItems() {
            if (this.importing) return;
            if (!this.entry.name || !this.entry.name.trim()) {
                this.$toast.error(this.$t("offer.import_toast_name_required"));
                return;
            }
            this.importing = true;

            const rate = parseFloat(this.dph()) || 0;
            const v = this.entry.values || {};
            const num = (x) =>
                x === "" || x === null || x === undefined
                    ? null
                    : parseFloat(String(x).replace(",", "."));

            const cenaBez = num(this.price);
            const cenaDo =
                this.typeCena === 1 || this.typeCena === 4
                    ? num(this.price_to)
                    : null;
            const withDph = (val) =>
                rate > 0 && val != null
                    ? parseFloat((val * (1 + rate / 100)).toFixed(2))
                    : null;

            const payload = {
                source_uuid: this.entry.uuid,
                source_offer: this.uuidOffer,
                interny_nazov: this.entry.name,
                verejny_nazov: this.entry.name,
                verejny_popis: this.entry.text || null,
                interny_popis: this.entry.inter_note || null,
                type_cena: this.typeCena,
                dph: rate > 0 ? rate : null,
                jednotka: this.entry.unit || null,
                pocet: num(v.number_of),
                pocet_do: num(v.number_of_to),
                sadzba: num(v.tariff),
                cena_bez_dph: cenaBez,
                cena_do: cenaDo,
                cena_s_dph: withDph(cenaBez),
                cena_s_dph_do: withDph(cenaDo),
            };

            axios
                .post("/api/items/importFromEntry", payload)
                .then((res) => {
                    this.importing = false;
                    this.importedLocal = true;
                    if (res.data && res.data.status === "updated") {
                        this.$toast.success(this.$t("offer.import_toast_updated"));
                    } else {
                        this.$toast.success(this.$t("offer.import_toast_saved"));
                    }
                })
                .catch(() => {
                    this.importing = false;
                    this.$toast.error(this.$t("offer.import_toast_error"));
                });
        },
        inter_note_click() {
            this.inter_note_check = true;
            this.$nextTick(() => {
                this.$refs[`inter_poznamka`].focus();
            });
        },
        changeCommaToDot() {
            this.entry.values.tariff = parseFloat(
                this.entry.values.tariff.toString().replace(",", ".").replace(" ", "")
            );
        },
        changeTypeCena() {
            if (this.typeCena == 2 && this.entry.unit == "hod") this.entry.unit = "";
        },
        matchName(current) {
            var dots = "";
            if (current.length > 47) {
                current = current.substr(0, 47);
                dots = "...";
            }
            if (!this.entry || !this.entry.name) return current;
            let reggie = new RegExp(this.entry.name, "ig");
            let found = current.search(reggie) !== -1;
            return !found
                ? current
                : current.replace(reggie, "<b>" + this.entry.name + "</b>") + dots;
        },
        SetSimilar(sim_entry) {
            if (sim_entry.label)
                this.entry.name =
                    sim_entry.verejny_nazov == null
                        ? sim_entry.nazov
                        : sim_entry.verejny_nazov;
            else this.entry.name = sim_entry.nazov;
            this.entry.text = sim_entry.text;
            this.entry.inter_note = sim_entry.inter_note ? sim_entry.inter_note : "";
            this.entry.exclude = true;
            if (sim_entry.nezobrazovat_cena == 0) this.entry.exclude = false;

            // type_cena == null => "Len cena" (fixna cena) => offer typ 1 (price_from)
            this.typeCena =
                sim_entry.type_cena == null
                    ? 1
                    : parseInt(sim_entry.type_cena);
            this.entry.type = info.types[this.typeCena] || info.types[1];

            this.entry.dph = sim_entry.dph;
            this.discountEur = sim_entry.discount_type == 1 ? true : false;

            if (this.typeCena == 2) {
                this.entry.unit = sim_entry.jednotka;
                if (sim_entry.jednotka == "new") this.entry.unit = "hod";
                if (sim_entry.jednotka == null) this.entry.unit = "";
                this.isOwnPrice = true;
            }

            this.entry.values = {
                number_of: parseFloat(sim_entry.pocet_hodin),
                number_of_to: parseFloat(sim_entry.pocet_hodin_do),
                tariff: parseFloat(sim_entry.hodinova_sadzba),
                price_from: parseFloat(sim_entry.cena),
                price_to: parseFloat(sim_entry.cena_do),
                auto_price:
                    parseFloat(sim_entry.pocet_hodin) *
                    parseFloat(sim_entry.hodinova_sadzba),
                own_price: parseFloat(sim_entry.cena),
                discount: parseFloat(sim_entry.zlava),
            };

            this.showDiscount = false;
            this.showText = false;

            if (this.entry.text) this.showText = true;
            if (this.entry.values.discount != 0) this.showDiscount = true;

            if (sim_entry.files) this.entry.files = sim_entry.files;

            if (sim_entry.subentries) {
                this.entry.subEntries = [];
                sim_entry.subentries.forEach((sub) => {
                    let subEntry = {};
                    subEntry["id"] = sub.line;
                    subEntry["uuid"] = this.makeuuid(6);
                    subEntry["component"] = SubEntry;
                    let two = {
                        name: sub.nazov_polozka,
                        text: sub.text_polozka,
                        type:
                            sub.type_cena_polozka == null
                                ? info.types[1]
                                : info.types[parseInt(sub.type_cena_polozka)] ||
                                  info.types[1],
                        values: {
                            number_of:
                                sub.hodiny_polozka == null ? 0 : parseFloat(sub.hodiny_polozka),
                            number_of_to:
                                sub.hodiny_do_polozka == null
                                    ? 0
                                    : parseFloat(sub.hodiny_do_polozka),
                            tariff:
                                sub.sadzba_polozka == null ? 0 : parseFloat(sub.sadzba_polozka),
                            price_from: 0,
                            price_to:
                                sub.cena_do_polozka == null
                                    ? 0
                                    : parseFloat(sub.cena_do_polozka),
                            auto_price:
                                sub.cena_polozka == null ? 0 : parseFloat(sub.cena_polozka),
                            own_price:
                                sub.cena_polozka == null ? 0 : parseFloat(sub.cena_polozka),
                            from_to_price: 0,
                            discount:
                                sub.zlava_polozka == null ? 0 : parseFloat(sub.zlava_polozka),
                        },
                        exclude: sub.nezobrazovat_cena_polozka,
                    };
                    two["unit"] = sub.jednotka_polozka;
                    if (sub.type_cena_polozka == 2) {
                        if (sub.jednotka_polozka == null) two["unit"] = "null";
                        two["isOwnPrice"] = true;
                    }
                    if (sub.type_cena_polozka == 1) {
                        two.values.price_from =
                            sub.cena_polozka == null ? 0 : parseFloat(sub.cena_polozka);
                        two.values.from_to_price =
                            sub.cena_polozka + " - " + sub.cena_do_polozka;
                    }
                    subEntry["data"] = two;
                    subEntry["data"] = two;
                    this.entry.subEntries.push(subEntry);
                });
            }

            this.showSimilar = false;
        },
        SimilarEntries() {
            if (this.entry && this.entry.name && this.entry.name.length > 1) {
                if (this.SearchEntries)
                    if (this.SearchEntries.length == 0) this.showSimilar = false;
            }
        },
        saveAllAfterChange() {
            if (this.getTariff) this.entry.values.tariff = this.newTariff;
            this.sendData();
        },
        round(num, decimalPlaces = 0) {
            return Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
        },
        //------entry functions------------------
        handleInput(field, cssClass) {
            const value = this.entry.values[field];
            let length = value ? value.toString().length : 0;

            let width = (length + 1) * 9;
            if (length === 0) {
                this.entry.values[field] = 0;
                width += 9;
            }

            $(`.${this.id}${cssClass} .v-text-field__slot input`).css("width", width);

            if (field === "tariff" && this.entry.type.id === 2) {
                this.isOwnPrice = false;
            }

            this.priceNumberTariff(3);
            this.saveAllAfterChange();
        },
        handleBlur(field, cssClass) {
            let value = this.entry.values[field];

            if (value == null || isNaN(value) || value < 0) {
                this.entry.values[field] = 0;
                value = 0;
            }

            let str = value.toString().replace(",", ".").replace(" ", "");
            str = (Math.round(parseFloat(str) * 100) / 100).toString();

            const index = str.indexOf(".");
            if (index !== -1) {
                str = str.slice(0, index + 3);
            }
            this.entry.values[field] = parseFloat(str);

            let length = this.entry.values[field].toString().length;
            let width = (length + 1) * 9;
            if (length === 0) {
                this.entry.values[field] = 0;
                width += 9;
            }

            $(`.${this.id}${cssClass} .v-text-field__slot input`).css("width", width);

            this.priceNumberTariff(0);
            this.saveAllAfterChange();
        },

        stepper(id, type) {
            if (this.entry && this.entry.type && this.entry.type.id == 2) this.isOwnPrice = false;
            if (id == 1) {
                if (type == 1)
                    this.entry.values.number_of =
                        parseFloat(this.entry.values.number_of) + 1;
                if (type == 0 && this.entry.values.number_of > 0)
                    this.entry.values.number_of =
                        parseFloat(this.entry.values.number_of) - 1;
                this.handleBlur('number_of', 'InputPocet')
                this.priceNumberTariff(3);
            }
            if (id == 2) {
                if (type == 1)
                    this.entry.values.tariff = parseFloat(this.entry.values.tariff) + 1;
                if (type == 0 && this.entry.values.tariff > 0)
                    this.entry.values.tariff = parseFloat(this.entry.values.tariff) - 1;
                this.handleBlur('tariff', 'InputSadzba')
                this.priceNumberTariff(3);
            }
            if (id == 3) {
                if (type == 1) this.entry.values.discount += 10;
                if (type == 0 && this.entry.values.discount > 0)
                    if (this.entry.values.discount <= 10) this.entry.values.discount = 0;
                    else this.entry.values.discount -= 10;
            }
            if (id == 4) {
                if (type == 1)
                    this.entry.values.number_of_to =
                        parseFloat(this.entry.values.number_of_to) + 1;
                if (type == 0 && this.entry.values.number_of_to > 0)
                    this.entry.values.number_of_to =
                        parseFloat(this.entry.values.number_of_to) - 1;
                this.handleBlur('number_of_to', 'InputPocet')
                this.priceNumberTariff(0);
            }
        },
        cal_price() {
            this.entry.values.subentries_price = 0;
            this.entry.values.subentries_price_to = 0;
            this.entry.values.subentries_price_discount = 0;
            this.entry.values.subentries_price_to_discount = 0;
            let prices = {
                price: 0,
                price_discount: 0,
                price_to: null,
                price_to_discount: null,
            };
            if (this.entry && this.entry.type && this.entry.type.id == 0) {
                this.entry.unit = "hod";
                prices.price = this.entry.values.auto_price - this.autoPriceDiscount();
                prices.price_discount = this.autoPrice();

                prices.price_to = this.entry.values.auto_price - this.autoPriceDiscount();
                prices.price_to_discount = this.autoPrice();
            }
            if (this.entry && this.entry.type && this.entry.type.id == 2) {
                prices.price = this.entry.values.own_price - this.ownPriceDiscount();
                prices.price_discount = this.ownPrice();

                prices.price_to = this.entry.values.own_price - this.ownPriceDiscount();
                prices.price_to_discount = this.ownPrice();
            }
            if (this.entry && this.entry.type && this.entry.type.id == 3) {
                prices.price = this.subEntriesPrice_ - this.subEntriesPriceDiscount(this.subEntriesPrice_);
                prices.price_discount = this.subEntriesPrice();
                prices.price_to = this.subEntriesPrice_ - this.subEntriesPriceDiscount(this.subEntriesPrice_);
                prices.price_to_discount = this.subEntriesPrice();
                // is in range from - to 
                if (this.subEntriesPrice_ != this.subEntriesPriceTo_) {
                    prices.price = this.subEntriesPrice_ - this.subEntriesPriceDiscount(this.subEntriesPrice_);
                    prices.price_discount = this.rangePrice(true).from;
                    prices.price_to = this.subEntriesPriceTo_ - this.subEntriesPriceDiscount(this.subEntriesPriceTo_);
                    prices.price_to_discount = this.rangePrice(true).to;
                }
            }
            if (this.entry && this.entry.type && (this.entry.type.id == 1 || this.entry.type.id == 4)) {
                this.entry.unit = this.entry.type.id == 1 ? "" : "hod";
                prices.price = this.entry.values.price_from - this.rangePriceDiscount().from;
                prices.price_discount = this.rangePrice().from;

                prices.price_to = this.entry.values.price_to - this.rangePriceDiscount().to;
                prices.price_to_discount = this.rangePrice().to;
            }

            this.price = parseFloat(Math.round(prices.price * 100) / 100);
            this.price_discount = parseFloat(
                Math.round(prices.price_discount * 100) / 100
            );
            this.price_to = parseFloat(Math.round(prices.price_to * 100) / 100);
            this.price_to_discount = parseFloat(
                Math.round(prices.price_to_discount * 100) / 100
            );

            this.setSuffix();
        },
        setSuffix() {
            this.suffix.number_of.suffix = " " + this.entry.unit;
            this.suffix.number_of_to.suffix = " " + this.entry.unit;
            if (this.entry.unit != "")
                this.suffix.tariff.suffix = " " + this.currentCurrency + " /" + this.entry.unit;
            else this.suffix.tariff.suffix = " " + this.currentCurrency;

            //if(this.entry.values.auto_price != this.entry.values.own_price)
            //this.isOwnPrice = true
        },
        //poslanie dat parentovi
        sendData() {
            this.cal_price();
            this.sortSubEntry();
            this.entry["price"] = this.price;
            this.entry["price_discount"] = this.price_discount;
            this.entry["price_to"] = this.price_to;
            this.entry["price_to_discount"] = this.price_to_discount;
            this.entry["discount_type"] = this.discountEur ? 1 : 0;
            this.entry["price_without_discount"] = this.priceWithoutDiscount();
            this.entry["price_to_without_discount"] = this.priceWithoutDiscountTo();
            this.$emit("data", this.entry);
        },
        //ratanie (hodina * sadzba = cena podpoložky) a (vypisanie ceny od - do)
        priceNumberTariff(type = 0) {
            if (this.entry.values.number_of.toString().includes(",")) {
                this.entry.values.number_of = this.entry.values.number_of
                    .toString()
                    .replace(",", ".");
            }
            if (this.entry.values.tariff.toString().includes(",")) {
                this.entry.values.tariff = this.entry.values.tariff
                    .toString()
                    .replace(",", ".");
            }
            if (this.entry.values.number_of_to.toString().includes(",")) {
                this.entry.values.number_of_to = this.entry.values.number_of_to
                    .toString()
                    .replace(",", ".");
            }
            if (this.entry && this.entry.type && this.entry.type.id == 0) {
                this.entry.values.auto_price =
                    this.entry.values.number_of * this.entry.values.tariff;
            }
            if (this.entry && this.entry.type && this.entry.type.id == 1) {
                this.entry.values.price_from = parseFloat(
                    Math.round(this.entry.values.price_from * 100) / 100
                );
                this.entry.values.price_to = parseFloat(
                    Math.round(this.entry.values.price_to * 100) / 100
                );
            }
            if (this.entry && this.entry.type && this.entry.type.id == 2) {
                if (!this.isOwnPrice) {
                    this.entry.values.auto_price =
                        this.entry.values.number_of * this.entry.values.tariff;
                    if (type == 3) {
                        this.entry.values.own_price =
                            this.entry.values.number_of * this.entry.values.tariff;
                    }
                }
            }
            if (this.entry && this.entry.type && this.entry.type.id == 4) {
                this.entry.values.price_from =
                    this.entry.values.number_of * this.entry.values.tariff;
                this.entry.values.price_to =
                    this.entry.values.number_of_to * this.entry.values.tariff;
                this.entry.values.price_from = parseFloat(
                    Math.round(this.entry.values.price_from * 100) / 100
                );
                this.entry.values.price_to = parseFloat(
                    Math.round(this.entry.values.price_to * 100) / 100
                );
            }
        },
        //-----------end entry functions---------
        //-----------subentry functions------------------
        dataSubEntry(value, id) {
            this.setSubEntriesPrice();
            this.entry.subEntries[id].data = value;
            this.saveAllAfterChange();
        },
        sortSubEntry() {
            for (let index = 0; index < this.entry.subEntries.length; index++) {
                this.entry.subEntries[index].id = index;
            }
        },
        addSubEntry(type) {
            this.getSubTariff = false;
            if (type) {
                // this.getSubTariff = true
                // this.newSubTariff = this.entry.values.tariff
                // setTimeout(() => {
                //     this.getSubTariff = false
                // }, 100);
            }
            this.entry.subEntries.push({
                id: this.entry.subEntries.length,
                uuid: this.makeuuid(6),
                component: SubEntry,
                data: {},
            });
        },
        removeSubEntry(id) {
            const index = this.entry.subEntries.findIndex((f) => f.id === id);
            this.entry.subEntries.splice(index, 1);
            this.saveAllAfterChange();
        },
        makeuuid(length) {
            var result = "";
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
        getEntries: _.debounce(function() {
            if (this.entry && this.entry.name && this.entry.name.length > 1) {
                axios
                .get("/api/offer/entries/"+this.uuidOffer+"/"+this.entry.name)
                .then((response) => {
                    this.userEntries = response.data.entries;
                    this.ItemsAndPrices = response.data.ItemsAndPrices;
                });
            }
        }, 1000),

    },
    watch: {
        //zmena stavu podpoložky
        //0 - hodinovka
        //1 - od - do
        //2 - vlastna
        //3 - cena z podpoložiek
        //4 - hodiny od - do
        typeCena: function () {
            this.entry.type = info.types[this.typeCena];
            if (this.typeCena == 0) {
                this.entry.unit = "hod";
            }
            if (this.typeCena == 2) {
                if (this.entry.unit == "new") this.entry.unit = "hod";
                if (this.entry.unit == "null") this.entry.unit = "";
            }
            if (this.typeCena == 3) {
                this.entry.dph = 0;
                this.setSubEntriesPrice();
            }
            if (this.typeCena == 4) {
                this.entry.unit = "hod";
            }
            this.priceNumberTariff(0);
            this.saveAllAfterChange();
        },
        units: function () {
            var uniqueUnits = new Set();
            if (Array.isArray(this.units)) {
                this.units.forEach((unit) => {
                    uniqueUnits.add(unit.name);
                });
            } else if (this.units && typeof this.units === "object") {
                uniqueUnits.add(this.units.name);
            } else {
                console.warn("this.units is not an array or object:", this.units);
            }
            this.unitItems.forEach((item) => {
                uniqueUnits.add(item);
            });
            this.unitItems = Array.from(uniqueUnits);
        },
        discountEur: function () {
            if (this.showDiscount) {
                this.cal_price();
                this.saveAllAfterChange();
            }
        },
        currentCurrency: function () {
            this.updateSuffix()
        },
        "entry.name": function () {
            this.getEntries();
            this.saveAllAfterChange();
        },
        "entry.text": function () {
            this.saveAllAfterChange();
        },
        "entry.inter_note": function () {
            this.saveAllAfterChange();
        },
        "entry.exclude": function () {
            this.saveAllAfterChange();
        },
        "entry.unit": function () {
            this.saveAllAfterChange();
        },
        showText: function () {
            if (!this.showText) this.entry.text = "";
        },
        "entry.dph": function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.cal_price();
                this.saveAllAfterChange();
            }
        },
        "entry.values.discount": function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.calcOwnPriceDiscount();
            }
        },
        "entry.values.own_price": function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.calcOwnPrice();
            }
        },
        "entry.values.price_to": function (newVal, oldVal) {
            if (newVal > 10000000) {
                // Check if the value is greater than 10M
                this.entry.values.price_to = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0);
            this.saveAllAfterChange();
        },
        "entry.values.price_from": function (newVal, oldVal) {
            if (newVal > 10000000) {
                // Check if the value is greater than 10M
                this.entry.values.price_from = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0);
            this.saveAllAfterChange();
        },
        "default_dph": function () {
            if (this.default_dph != "") {
                this.entry.dph = this.default_dph;
            }
        },
        showSimilar: function (newVal, oldVal) {
            if (!newVal) {
                this.ItemsAndPrices = [];
                this.userEntries = [];
            }
        }
    },
    computed: {
        isImported() {
            if (this.importedLocal) return true;
            return (
                Array.isArray(this.importedSources) &&
                this.entry &&
                this.entry.uuid &&
                this.importedSources.includes(this.entry.uuid)
            );
        },
        SearchEntries() {
            this.showSimilar = false;
            if (this.entry && this.entry.name && this.entry.name.length > 1) {
                this.showSimilar = true;
                return { items: this.ItemsAndPrices, userEntries: this.userEntries };
            }
            return { items: [], userEntries: [] };
        },
    },
    mounted() {
        this.loadAiSettings();
        this.priceNumberTariff(0);
        $(".InputSadzba .v-input__control").click(function () {
            $(".InputSadzba #input-70").focus();
        });
        $(".InputPocet .v-input__control").click(function () {
            $(".InputPocet #input-70").focus();
        });
        $(".InputPocetTo .v-input__control").click(function () {
            $(".InputPocetTo #input-70").focus();
        });
        EventBus.$on('currencyChanged', (val) => {
            this.currentCurrency = val;
        });
        if (this.default_dph != "") {
            this.entry.dph = this.default_dph;
        }
        setTimeout(() => {
            this.handleBlur('number_of', 'InputPocet')
            this.handleBlur('number_of_to', 'InputPocetTo')
            this.handleBlur('tariff', 'InputSadzba')
        }, 2000);
    },
};
</script>
<style lang="scss">
.add-popis-mobile {

    p,
    span,
    strong,
    ul li,
    ol li,
    u {
        font-size: 14px !important;
    }
}

.ql-snow .ql-tooltip a.ql-action::after {
    content: "Upraviť" !important;
}

.ql-snow .ql-tooltip a.ql-remove::before {
    content: "Vymazať" !important;
}

.ql-snow .ql-tooltip::before {
    content: "URL:" !important;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "URL:" !important;
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: "Uložiť" !important;
}

.ql-snow .ql-tooltip {
    transform: translate(85px, 10px) !important;
}

.ql-container.ql-snow {
    border: 1px solid #dde3e8 !important;
    border-top: 0 !important;
}

.ql-toolbar.ql-snow {
    border: 1px solid #dde3e8 !important;
    margin-top: 1px;
}

.ql-snow .ql-toolbar button,
.ql-snow.ql-toolbar button {
    margin-right: 6px !important;

    svg {
        width: 18px !important;
    }
}
</style>
<style lang="scss" scoped>
.disable_price {
    .icons {
        width: 15px;
        display: flex;
        align-items: center;
        .info {
            position: relative;
            .info_icon {
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                cursor: pointer;
                svg {
                    width: 15px;
                    height: 15px;
                    margin: 0;
                }
                &.active {
                    svg {
                        fill: #f3385a;
                    }
                }
            }
        }
    }
}

.pridat_obrazky_text {
    position: relative;
    background-color: #fff;
    width: fit-content;
    padding: 0 25px;
    height: 40px;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    text-align: center;
    color: #212541;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border: 0;
    cursor: pointer;
    border-bottom-width: 0px;
    border-bottom-style: none;
    border-bottom-color: currentcolor;
    border-bottom: 2px solid #2ed8b6;

    box-shadow: 0px 1px 1px 0px #00000024;

    .file_count {
        position: absolute;
        top: 2px;
        right: 2px;
        font-size: 11px;
        color: white;
        background: #2ed8b6;
        font-weight: bold;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
    }
}

.roll-subentires {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 1px;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    margin-left: 2.2rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    line-height: 1;

    svg {
        width: 15px;
        height: 15px;
        rotate: 0deg;
        transition: all 0.15s ease;

        &.arrow_down {
            rotate: 180deg;
        }
    }
}

.arrow_up,
.arrow_down {
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.arrow_up {
    rotate: 180deg;
}

.entry_copy_drag {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-top: 2px;
    gap: 10px;

    .copy_entry {
        cursor: pointer;
        height: 20px;
        width: 15px;
    }
}

.inter_poznamka {
    display: flex;
    min-height: 20px;

    @media (max-width: 1200px) {
        margin-top: 20px;
    }

    a.one {
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: #a6a8b3 !important;
        cursor: pointer;
    }

    a.two {
        width: 100%;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: #212541 !important;
        cursor: pointer;
    }

    input {
        width: 100%;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: #212541 !important;

        padding-bottom: 9px;
        border-bottom: 1px solid #dde3e8;
    }
}

.subentries {
    @media (max-width: 1200px) {
        margin-top: 3rem !important;
    }
}

.mobile_price {
    @media (max-width: 1200px) {
        padding: 20px 10px;
        justify-content: flex-end !important;
    }
}

.mobile_discount {
    @media (max-width: 1200px) {
        display: grid !important;
        width: 100%;
    }

    .remove-sale,
    .add-sale {
        @media (max-width: 1200px) {
            border-bottom: 1px solid #dde3e8;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}

.roll {
    @media (max-width: 1200px) {
        width: 15px;
        height: 15px;
    }
}

.mobile_roll {
    @media (max-width: 1200px) {
        display: none !important;
    }
}

.mobile_nezapocitat {
    @media (max-width: 1200px) {
        justify-content: flex-end;
        position: relative;
        margin-top: 22px !important;
    }
}

.mobile_trash2 {
    @media (max-width: 1200px) {
        position: absolute;
        bottom: -15px;
        right: 64px;
    }
}

.similar_entries {
    z-index: 10000;
    position: absolute;
    left: 0;
    top: 56px;
    height: auto;
    max-height: 340px;
    min-width: 504px;
    box-shadow: 0px 2px 8px rgb(0 0 0 / 10%);
    border: 1px solid #dde3e8;
    background: #fff;
    overflow: auto;
    width: 100%;

    .database-items {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 5px 14px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        background: #383C4C;
        color: #fff;
        text-transform: uppercase;
    }

    .entry {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50%;
        padding: 14px;
        background: #fff;
        cursor: pointer;
        border-bottom: 1px solid #dde3e8;

        &:hover {
            background: #F7F8F8;
        }

        .left {
            display: flex;
            flex-direction: column;
            gap: 3px;
            flex: 4;

            h6.name {
                font-family: Roboto;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }

            span.description {
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #212541;
                opacity: 0.5;
            }
        }

        .right {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
}

.entry_tooltip {
    width: auto !important;
    min-width: 180px;
    bottom: 10px !important;
    right: -6px !important;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .line {
        width: 70%;
        height: 1px;
        background-color: #fff;
        opacity: 0.5;
        margin: 0 auto;
    }

    span {
        font-weight: bold;
    }
}

.entry_tooltip_roll {
    width: auto !important;
    min-width: 180px;
    bottom: 22px !important;

    @media (max-width: 1200px) {
        right: -8px !important;
    }

    @media (min-width: 1200px) {
        right: -10px !important;
    }
}

.cena_zero {
    width: 230px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.cena_one {
    width: 205px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.cena_two {
    width: 145px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.cena_three {
    width: 245px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.IndexPocetSub {
    width: 150px;
}

.InputSadzba,
.InputPocet {
    min-width: 110px;

    .suf {
        pointer-events: none;
        position: absolute;
        top: 30.2px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        opacity: 0.8;
    }
}

.IndexPocetSub {
    width: 150px;
}

.InputSadzba,
.InputPocet {
    min-width: 110px;

    .suf {
        pointer-events: none;
        position: absolute;
        top: 30.2px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }
}

.cont {
    position: relative;
    border-left: 2px solid #2ed8b6;
    background-color: #f7f8f8;
    margin-bottom: 25px;
    /*box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);*/
    border-radius: 5px;

    .info {
        position: relative;

        .info_icon {
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            float: right;

            img {
                width: 80%;
                height: 80%;
            }
        }

        .my_tooltip {
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #f3385a;
            box-sizing: border-box;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            padding: 10px;
            position: absolute;
            bottom: 25px;
            right: -5px;
            z-index: 10000;
            transition: opacity 0.5s ease-in-out;

            &::after {
                content: "";
                width: 15px;
                height: 15px;
                background: #f3385a;
                position: absolute;
                right: 8px;
                margin: auto;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }

            &.left {
                left: 0px;
                right: unset;

                &::after {
                    left: 4px;
                    right: unset;
                }
            }
        }

        &:hover {
            .my_tooltip {
                opacity: 1;
            }
        }
        
        &.show-tooltip {
            .my_tooltip {
                opacity: 1;
            }
        }
    }
    
    .roll-container {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .roll {
        cursor: pointer;
    }

    .roll.reverse {
        transform: rotate(180deg);
    }

    .add-subentry {
        background-color: #fff;
        width: 160px;
        height: 40px;
        border-radius: 4px;

        font: {
            family: Roboto;
            style: normal;
            weight: 400;
            size: 13px;
        }

        line-height: 15px;
        text-align: center;
        color: #212541;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        border-bottom: 2px solid #2ed8b6;
        box-shadow: 0px 1px 1px 0px #00000024;

        svg {
            margin-right: 5px;
        }

        @media (max-width: 1200px) {
            width: 90%;
            margin: 0 auto;
            margin-top: 70px;
        }
    }

    .offer-top {
        font-family: Roboto;

        @media (max-width: 1200px) {
            display: grid;
            width: 90%;
            margin: 0 auto;
            padding: 0 !important;
        }

        .popisNone {
            width: 140px;
            margin-left: 17px;
            padding-top: 8px;
            margin-top: 9px;
            display: flex;
            cursor: pointer;
            font-family: Roboto;
            font-weight: normal;
            text-decoration: underline;
            font-size: 13px;
            line-height: 15px;
            color: #a6a8b3;
        }

        .info {
            cursor: pointer;

            path {
                stroke: #ced0d5;
            }

            &:hover>path {
                stroke: #383c4c;
            }
        }

        .trash {
            cursor: pointer;

            @media (max-width: 1200px) {
                width: 50px;
                height: 23px;
            }

            path {
                stroke: #9598a7;
            }

            &:hover>path {
                stroke: #383c4c;
            }
        }

        .sum input {
            text-align: right;
        }

        padding: 20px 35px 10px 20px;
        display: flex;
        gap: 10px;
        align-items: flex-start;

        svg {
            @media (max-width: 1200px) {
                margin: 0;
                position: absolute;
                top: 8px;
                width: 15px;
                height: 15px;
                left: 12px;
            }
        }

        .textarea-icons {
            display: flex;
            gap: 30px;
            align-items: center;
            position: absolute;
            right: 20px;
            top: 9px;
            button{
                font-size: 14px;
                line-height: 16px;
                color: #212541CC;
                background: #ffffff;
                border: 1px solid #dde3e8;
                box-sizing: border-box;
                border-radius: 0;
                padding: 5px 10px;
            }
        }

        .editor-wrapper {
            position: relative;
        }

        .ai-generate-overlay {
            position: absolute;
            top: 60px;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 10px 14px;
            pointer-events: none;
            color: #9ca3af;
            font-style: italic;
            font-size: 13px;
            display: flex;
            align-items: flex-start;
        }

        .ai-generate-text {
            background: transparent;
        }

        .ai-generate-text .dots {
            display: inline-block;
            animation: ai-dots 1s steps(3, end) infinite;
        }

        @keyframes ai-dots {
            0% {
                clip-path: inset(0 3ch 0 0);
            }
            33% {
                clip-path: inset(0 2ch 0 0);
            }
            66% {
                clip-path: inset(0 1ch 0 0);
            }
            100% {
                clip-path: inset(0 0 0 0);
            }
        }

        .inputs {
            display: flex;
            flex-direction: column;
            max-width: 100%;
            width: 100%;

            @media (max-width: 1200px) {
                display: flex;
                flex-direction: column;
                width: 100%;
            }

            @media (max-width: 600px) {
                margin: 0 !important;
                margin-top: 20px !important;
                width: 100% !important;
            }

            .top-inputs {
                @media (max-width: 1200px) {
                    flex-direction: column;
                }

                @media (max-width: 600px) {
                    width: 100% !important;
                }

                display: flex;
                align-items: center;
                position: relative;
            }

            .name {
                width: 100%;
            }

            .unit {
                width: 150px;
            }

            .select {
                width: 220px;
            }

            .select_box {
                flex: 0 0 280px;
                max-width: 280px;
                align-self: stretch;

                @media (max-width: 1200px) {
                    flex: 1 1 100%;
                    max-width: none;
                    width: 100%;
                    margin-top: 0;
                }

                .price-type-select {
                    height: 100%;
                }
            }

            .price-for-hours {
                @media (max-width: 1200px) {
                    width: 120px;
                }
            }

            .price {
                width: 100px;

                @media (max-width: 1200px) {
                    display: none;
                }
            }

            .inline-price-mobile {
                display: none;

                @media (max-width: 1200px) {
                    display: flex;
                }

                .price {
                    @media (max-width: 1200px) {
                        width: 50%;
                        display: block;

                        &:first-child {
                            input {
                                border-left: 1px solid #dde3e8 !important;
                            }
                        }
                    }
                }
            }

            .inline-inputs {
                display: flex;

                @media (max-width: 600px) {
                    flex-direction: column;
                    width: 100% !important;
                }

                .price-for-hours {
                    @media (max-width: 1200px) {
                        width: 50%;
                    }

                    @media (max-width: 600px) {
                        width: 100% !important;
                    }

                    &:first-child {
                        input {
                            border-right: 0;
                        }
                    }

                    input {
                        border: 1px solid #dde3e8;
                    }
                }
            }

            .form-floating {
                label {
                    color: #212541 !important;
                }

                height: 56px;

                .stepper {
                    position: absolute;
                    right: 0;
                    top: 0;
                    display: grid;
                    height: 100%;
                    width: 32px;

                    span {
                        cursor: pointer;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        &:first-child {
                            border-bottom: 1px solid #ecf0f3;
                        }
                    }
                }

                input::-webkit-calendar-picker-indicator {
                    opacity: 1;
                    font-size: 10px;
                    position: absolute;
                    right: 10px;
                    top: 20px;
                }

                select {
                    font: {
                        style: normal;
                        weight: normal;
                        size: 14px;
                    }

                    @media (max-width: 1200px) {
                        border: 1px solid #dde3e8;
                    }

                    line-height: 16px;
                    color: #212541 !important;
                    background-color: #ffffff;
                    border: 1px solid #dde3e8;
                    box-sizing: border-box;
                    border-radius: 0;
                    border-left: 0;

                    &:focus {
                        box-shadow: none;
                    }
                }

                .form-select {
                    background-image: url("/img/create_offer/select-arrow.svg");
                    background-size: 9px 9px;
                }

                input {
                    font: {
                        style: normal;
                        weight: normal;
                        size: 14px;
                    }

                    line-height: 16px;
                    color: #212541;
                    background: #ffffff;
                    border: 1px solid #dde3e8;
                    box-sizing: border-box;
                    text-transform: uppercase;
                    border-radius: 0;
                    border-left: 0;

                    &:focus {
                        box-shadow: none;
                    }
                }

                label {
                    padding: 20px 0.75rem;

                    font: {
                        style: normal;
                        weight: bold;
                        size: 14px;
                    }

                    text-transform: uppercase;
                }

                .form-floating {
                    height: 56px;

                    .stepper {
                        position: absolute;
                        right: 0;
                        top: 0;
                        display: grid;
                        height: 100%;
                        width: 32px;

                        span {
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            &:first-child {
                                border-bottom: 1px solid #ecf0f3;
                            }
                        }
                    }

                    text-transform: uppercase;
                    line-height: 16px;
                    color: #212541;
                }
            }
        }

        .add-popis-mobile {
            display: none;

            @media (max-width: 1200px) {
                display: block;
            }

            @media (max-width: 600px) {
                width: 100% !important;
            }

            //border: 1px solid #DDE3E8;
            textarea {
                padding-top: 4px !important;
                border: 0 !important;
                border-top: 28px solid transparent !important;
                border-radius: 0 !important;

                @media (max-width: 1200px) {
                    height: 150px;
                }
            }

            svg {
                position: absolute;
                top: 3px;
                right: -14px;
                width: 17px;

                @media (max-width: 1200px) {
                    position: absolute;
                    top: 6px;
                    right: -6px;
                    width: 20px;
                    left: auto;
                }
            }
        }

        .add-popis {
            @media (max-width: 1200px) {
                display: none;
            }

            .form-floating {

                //border: 1px solid #DDE3E8;
                textarea {
                    padding-top: 4px !important;
                    border: 0 !important;
                    border-top: 28px solid transparent !important;
                    height: 80px;

                    font: {
                        style: normal;
                        weight: 500;
                        size: 14px;
                    }

                    line-height: 16px;
                    color: #212541;
                    background: #ffffff;
                    border: 1px solid #dde3e8;
                    box-sizing: border-box;
                    border-radius: 0;

                    &:focus {
                        box-shadow: none;
                    }
                }
            }
        }
    }

    .offer-bottom {
        display: flex;
        justify-content: space-between;
        padding: 15px 2.2rem 15px 2.2rem;
        border-top: 1px solid #dde3e8;
        margin-top: 25px;

        @media (max-width: 1200px) {
            flex-direction: column;
            gap: 20px;
        }

        .add-sale {
            cursor: pointer;
            padding: 16px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            font: {
                family: Roboto;
                style: normal;
                weight: 400;
                size: 14px;
            }

            svg {
                margin-right: 8px;
            }

            line-height: 16px;
            color: #212541;
            width: 100%;
        }

        .remove-sale {
            cursor: pointer;

            .remove {
                padding: 16px;
            }

            display: flex;
            justify-content: flex-end;
            align-items: center;

            font: {
                family: Roboto;
                style: normal;
                weight: 400;
                size: 14px;
            }

            svg {
                margin-right: 8px;
            }

            line-height: 16px;
            color: #212541;
            width: 100%;
        }

        .input-group {
            height: 100%;
            width: 98px;
            margin: 0;
            border-right: none;

            input {
                border-top: 0;
                border-bottom: 0;
                border-right: 0;
                border-radius: 0;

                &:focus {
                    box-shadow: none;
                    border-color: #ced4da;
                }
            }

            .stepper {
                position: absolute;
                right: 0;
                top: 0;
                display: grid;
                height: 100%;
                width: 32px;
                z-index: 3;

                span {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &:first-child {
                        border-bottom: 1px solid #ecf0f3;
                    }
                }
            }
        }

        .summary-bottom {
            width: auto;
            padding: 16px 30px 16px 40px;
            white-space: nowrap;

            @media (max-width: 1200px) {
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            span {
                font: {
                    weight: normal;
                }
            }

            font: {
                style: normal;
                weight: bold;
                size: 18px;
            }

            line-height: 21px;
            color: #212541;
        }
    }
}

.sum>.form-control:focus~label,
.sum>.form-control:not(:placeholder-shown)~label,
.sum>.form-select~label {
    transform: translateY(-14px) translateX(-7px);
    font-size: 12px !important;
}
</style>

<style lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.combobox {
    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }

    @media (max-width: 600px) {
        width: 100% !important;
    }

    .v-input {
        height: 56px;
        width: 110px;

        @media (max-width: 1200px) {
            width: 100%;
        }
    }

    .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
        background: #fff;
    }

    .v-input__slot {
        &:hover {
            background: #fff !important;
        }

        @media (max-width: 1200px) {
            border-left: 1px solid #dde3e8 !important;
            border-bottom: 0px !important;
        }

        border-top: 1px solid #dde3e8 !important;
        border-bottom: 1px solid #dde3e8 !important;
        border-right: 1px solid #dde3e8 !important;
        border-radius: 0 !important;

        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541 !important;
            flex: initial !important;
            width: 80px !important;
        }
    }

    .v-text-field>.v-input__control>.v-input__slot {
        &:after {
            content: none !important;
        }

        &:before {
            content: none !important;
        }
    }

    .v-label.v-label--active.theme--light {
        left: -8px !important;
        top: 12px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 14px !important;
        text-transform: uppercase !important;
        line-height: 16px !important;
        color: #212541 !important;
        opacity: 0.65 !important;
        margin-bottom: 0;
    }
}

// .select_box štýly su definovane vyssie v .top-inputs (flush variant pre PriceTypeSelect)

.InputSadzba,
.InputPocet {
    .v-text-field__slot {
        &:hover {
            background: #fff !important;
        }

        @media (max-width: 1200px) {
            width: 127.8px;
            border-top: 1px solid #dde3e8;
            border-left: 1px solid #dde3e8;
        }

        height: 58px;
        margin-bottom: 0 !important;
        border-left: 1px solid #dde3e8 !important;
        border-top: 1px solid #dde3e8 !important;
        border-bottom: 1px solid #dde3e8 !important;
        border-right: 1px solid #dde3e8 !important;
        border-radius: 0 !important;
        padding: 0.5rem 0.75rem;

        input {
            width: 30px;
            min-width: 50px;
            padding-left: 3px;
            padding-top: 0;
            padding-bottom: 0;
            margin-top: 20px;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541 !important;
            display: flex !important;
            flex: initial !important;
        }
    }

    .v-text-field__suffix {
        pointer-events: none !important;
        width: 85px !important;
        margin-top: 20px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .v-label.v-label--active.theme--light {
        left: 6px !important;
        top: 26px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        line-height: 16px !important;
        color: #212541 !important;
        opacity: 0.65 !important;
        margin-bottom: 0;
        -webkit-transform: translateY(-18px) scale(0.75);
        transform: translateY(-18px) scale(0.75);
    }

    .v-input .v-label {
        left: 6px !important;
        top: 26px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        line-height: 16px !important;
        color: #212541 !important;
        opacity: 0.65 !important;
        margin-bottom: 0;
        -webkit-transform: translateY(-18px) scale(0.75);
        transform: translateY(-18px) scale(0.75);
    }

    .v-text-field>.v-input__control>.v-input__slot {
        &:after {
            content: none !important;
        }

        &:before {
            content: none !important;
        }
    }

    .v-input {
        height: 56px;
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}

/******
* new codes
***/

.subentry-actions-holder {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 0 4.05rem 0 2.2rem;
}

.subentry-actions-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 20px;
}

.entry-box {
    background: #fff;
    border-left: 1px solid #dde3e8;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    flex: 1;
}

.cont .offer-top .summary .summary-top .sum.form-floating input {
    border-bottom: 2px solid #989898 !important;
    max-width: 302px;
    width: 100%;
}

.summary {
    @media (max-width: 1200px) {
        margin-left: 0;
    }

    .mobile_trash {
        @media (max-width: 1200px) {
            position: absolute;
            position: absolute;
            bottom: -45px;
            right: 47px;
        }
    }

    .icons {
        margin-left: 15px;
    }

    .summary-top {
        position: relative;
        display: flex;
        align-items: center;

        .sum.form-floating {
            width: 300px;
            margin-left: auto;

            @media (max-width: 1200px) {
                width: 100%;
            }

            input {
                font: {
                    style: normal;
                    weight: bold;
                    size: 14px;
                }

                line-height: 16px;
                color: #212541;
                background: #ffffff;
                border: 1px solid #dde3e8;
                box-sizing: border-box;
                border-radius: 0;

                &:focus {
                    box-shadow: none;
                }
            }

            label {
                padding: 20px 0.75rem;
                padding-right: 0;

                font: {
                    style: normal;
                    weight: bold;
                    size: 14px;
                }

                text-transform: uppercase;
                line-height: 16px;
                color: #212541;
            }

            &>label {
                right: 0;
                left: unset;
            }
        }
    }

    .summary-bottom {
        display: flex;
        align-items: center;

        .block {
            @media (max-width: 1200px) {
                order: 2;
                margin-left: 5px;
            }

            font: {
                style: normal;
                weight: normal;
                size: 14px;
            }

            line-height: 16px;
            color: #212541;
        }

        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 0px 0 10px;
            background: #c7d4eb;
            border-radius: 25px;

            @media (max-width: 500px) {
                margin: 0;
            }
        }

        .summary-top {
            display: flex;
            align-items: center;

            .sum.form-floating {
                width: 300px;
                margin-left: auto;

                @media (max-width: 1200px) {
                    width: 90%;
                }

                @media (max-width: 1200px) {
                    width: 140px;
                }

                input {
                    font: {
                        style: normal;
                        weight: bold;
                        size: 14px;
                    }

                    line-height: 16px;
                    color: #212541;
                    background: #ffffff;
                    border: 1px solid #dde3e8;
                    box-sizing: border-box;
                    border-radius: 0;

                    &:focus {
                        box-shadow: none;
                    }
                }

                label {
                    padding: 20px 0.75rem;
                    padding-right: 0;

                    font: {
                        style: normal;
                        weight: bold;
                        size: 14px;
                    }

                    text-transform: uppercase;
                    line-height: 16px;
                    color: #212541;
                }

                &>label {
                    right: 0;
                    left: unset;
                }
            }
        }

        .toggle label {
            @media (max-width: 600px) {
                width: 70%;
            }
        }

        .toggle {
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #ffffff;
            border-radius: 3px;
            transition: all 0.2s ease;

            &.percent-eur {
                border-color: #C7D4EB !important;
                background: #C7D4EB !important;
            }

            &:focus {
                outline: 0;
            }

            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }

            &.percent-eur:checked {
                border-color: #C7D4EB !important;
                background: #C7D4EB !important;
            }

            &:checked {
                border-color: #2ed8b6;
                background: #2ed8b6;
            }

            &:checked:after {
                transform: translatex(20px);
            }
        }
    }
}

.summary-last {
    position: relative;
    display: flex;
    align-items: center;

    .sum.form-floating {
        width: 300px;
        margin-left: auto;

        @media (max-width: 1200px) {
            width: 100%;
        }

        input {
            font: {
                style: normal;
                weight: bold;
                size: 14px;
            }

            line-height: 16px;
            color: #212541;
            background: #ffffff;
            border-bottom: 2px solid #989898 !important;
            box-sizing: border-box;
            border-radius: 0;

            &:focus {
                box-shadow: none;
            }
        }

        label {
            padding: 20px 0.75rem;
            padding-right: 0;

            font: {
                style: normal;
                weight: bold;
                size: 14px;
            }

            text-transform: uppercase;
            line-height: 16px;
            color: #212541;
        }

        &>label {
            right: 0;
            left: unset;
        }
    }
}

.check-holder {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 3px;
    position: absolute;
    z-index: 100;

    span {
        color: #212541;
        font-size: 10px;
        font-weight: 600;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0;
        background: #c7d4eb !important;
        border-radius: 25px !important;

        @media (max-width: 500px) {
            margin: 0;
        }
    }

    .toggle label {
        @media (max-width: 600px) {
            width: 70%;
        }
    }

    .toggle {
        height: 11px;
        width: 19px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        border: none !important;
        transition: all 0.2s ease;

        &.percent-eur {
            border-color: #C7D4EB !important;
            background: #C7D4EB !important;
        }

        &:focus {
            outline: 0;
        }

        &:after {
            content: "";
            position: absolute;
            top: 2px;
            left: 2px;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: white;
            box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
            transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
        }

        &.percent-eur {
            border-color: #C7D4EB !important;
            background: #C7D4EB !important;
        }

        &:checked {
            border-color: #C7D4EB !important;
            background: #C7D4EB !important;
        }

        &:checked:after {
            transform: translatex(8px);
        }
    }

    &+div+.v-text-field__slot .v-label {
        display: block;
    }
}

.cont .offer-top .inputs .top-inputs>.inline-inputs {
    flex: 0 1 100%;
}

.cont .offer-top .inputs .top-inputs>.inline-inputs>* {
    flex: 1 1 auto;
}

.entry_right {
    padding-left: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

.action-icon-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover .action-tooltip {
        opacity: 1;
        transform: translateY(-50%);
        pointer-events: none;
    }
}

.action-icon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e7eaef;
    background: #fff;
    border-radius: 10px;
    color: #8a93a6;
    cursor: pointer;
    padding: 0;
    transition: background 0.15s, border-color 0.15s, color 0.15s;

    svg {
        width: 17px;
        height: 17px;
        display: block;
        margin: 0 !important;
    }

    &:hover {
        background: #f6f9fc;
        border-color: #d7dde6;
        color: #5a6473;
    }

    &--import:hover {
        background: #eef7ff;
        border-color: #bcdcff;
        color: #2f7be0;
    }
    &--done,
    &--done:hover {
        background: #e6faf4;
        border-color: #b6ecdc;
        color: #13b98c;
    }
    &--active,
    &--active:hover {
        background: #fff4e6;
        border-color: #ffd8a8;
        color: #e8830c;
    }
    &--danger:hover {
        background: #fdecef;
        border-color: #f6c4cf;
        color: #e1466f;
    }
    &:disabled {
        cursor: default;
    }
}

.action-tooltip {
    position: absolute;
    right: calc(100% + 10px);
    top: 50%;
    transform: translateY(calc(-50% + 4px));
    width: 240px;
    background: #222a38;
    color: #fff;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    line-height: 1.45;
    font-weight: 400;
    text-align: left;
    padding: 10px 12px;
    border-radius: 9px;
    box-shadow: 0 10px 26px rgba(20, 28, 48, 0.22);
    opacity: 0;
    pointer-events: none;
    z-index: 10001;
    transition: opacity 0.16s ease, transform 0.16s ease;

    &__title {
        display: block;
        font-weight: 700;
        font-size: 12.5px;
        margin-bottom: 5px;
    }
    &__line {
        height: 1px;
        background: rgba(255, 255, 255, 0.14);
        margin: 0 0 6px;
    }

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: -5px;
        width: 10px;
        height: 10px;
        background: #222a38;
        transform: translateY(-50%) rotate(45deg);
        border-radius: 2px;
    }

    @media (max-width: 1200px) {
        right: auto;
        left: 50%;
        top: auto;
        bottom: calc(100% + 10px);
        transform: translateX(-50%);

        &::after {
            top: auto;
            bottom: -5px;
            right: auto;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
        }
    }
}

@media (max-width: 1200px) {
    .action-icon-wrap:hover .action-tooltip {
        transform: translateX(-50%);
    }
}

.popeditor-trigger-holder {
    width: fit-content;
    padding: 0 35px;
}

.popeditor-trigger-holder .popisNone {
    color: #a6a8b3;
    cursor: pointer;
    text-decoration: underline;
    font-size: 14px;
    padding-left: 0px;
}

.offer-top .inputs .form-floating {
    position: relative;
}

.inputs-name-holder {
    position: relative;
}

.saled-price {
    color: #a50a00;
    font-weight: 700;
    font-size: 12px;
    text-decoration: line-through;
    position: absolute;
    left: 7px;
    top: 5px;
}

.offer-top .inputs .form-floating.price {
    width: auto !important;
    flex: 0 0 auto;
}
</style>
